function getPagePath(): string {
  const { pathname } = window.location

  const pathParts = pathname.split('/')
  const index = pathParts.indexOf('product')

  return index !== -1
    ? pathParts.reduce((accum, current, currIndex) =>
        currIndex > index + 1 ? `${accum}/${current}` : accum
      )
    : ''
}

export default getPagePath
